import React, { useEffect } from "react";

const Healthray = () => {
  useEffect(() => {
    const existingScript = document.getElementById("loadScript");
    const fab = document.getElementById("fabs");
    if (fab) {
      fab.style.display = "block";
    }
    if (existingScript) return;
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://node.healthray.com/user_inquiry_form/loadScript.js";
    script.charset = "UTF-8";
    script.setAttribute(
      "data-token",
      "b46f5a4510bb6d3ed99864f794eb6dcc5d85b622d4d89e4c56174deddeb28995"
    );
    script.setAttribute("id", "loadScript");
    document.body.appendChild(script);
    // eslint-disable-next-line consistent-return
    return () => {
      const scriptToRemove = document.getElementById("loadScript");

      if (scriptToRemove) {
        scriptToRemove.remove();
      }
      if (fab) {
        fab.style.display = "none";
      }
    };
  }, []);

  return <></>;
};

export default Healthray;
